import React, { Component } from 'react';

import NavBarGroupCt from './NavBarGroupCt';
import SideBarGroupCt from './SideBarGroupCt';

import { DataListWrapper } from '../../../commonComponents/DataTable/DataTablePs'
import parentStateHandler from '../../../commonJS/parentStateHandler';

//import { getNewsTableList } from '../../../commonComponents/asyncTableList'

export default class SaleSkyDashboardCt extends Component {
  constructor(props) {
    super(props);
    this.handlers = {
      stateHandler: (states, newValues) => {
        parentStateHandler({ states, newValues, parentThis: this });
      }
    }

    this.state = {
      defaultDataList: new DataListWrapper([], []),
      filteredDataList: new DataListWrapper([], []),
      tableFrom: ''
    }

    this.getDataListFromPropsFunc = this.getDataListFromPropsFunc.bind(this);
  }

  getDataListFromPropsFunc(sortedData, tableFrom, cb) {
    this.setState({
      defaultDataList: sortedData,
      filteredDataList: sortedData,
      tableFrom: tableFrom,
    });

    /*
        為了讓NavBarGroupCt與SideBarGroupCt能夠溝通( 當搜尋bar onChange的時候, SideBarGroupCt裡面的TableCt也要跟著filter )
        Table Filter的function就得寫在他們共同的父親SaleSkyDashboardCt,
        DataListWrapper物件則由SaleSkyDashboardCt透過props傳給NewsDataTableCt.
        但如果SaleSkyDashboardCt還存有上一個Tab的DataListWrapper(如Customer),
        而使用者切換到News, 會發生'將Customer的DataList傳給News'的悲劇.
        所以我設了一個tableFrom的prop(只是個字串),當props傳下去的時候,檢查傳下去的資料,是不是現在的Ct所需要的.
        若不是的話, 就顯示'讀取中 請稍後',
        直到正確的DataList傳下去,才會顯示Table.
        
        一定有更好的做法,不過時間太趕想不出來. 請高手改進.

        目前有在使用搜尋bar的function只有News跟Customer兩個Table
    */

    // 更新搜尋結果
    if (cb) cb();
  }

  render() {
    let { filteredDataList, tableFrom } = this.state;

    return (
      <div id='div-dashboard-container'>
        <NavBarGroupCt
          userName={this.props.userName}
          stateHandler={this.props.stateHandler}
          logoutHandler={this.props.logoutHandler}
          userPhotoSrc={this.props.userPhotoSrc}
          onSidebarSizeToggle={this.props.onSidebarSizeToggle}
          isBigSideBar={this.props.isBigSideBar}
          propsPackageFromSkyFamily={this.props.propsPackageFromSkyFamily}
          companyInfo={this.props.companyInfo} />

        <SideBarGroupCt
          companyInfo={this.props.companyInfo}
          content={this.props.content}
          routeHandler={this.props.routeHandler}
          routes={this.props.routes}
          pathname={this.props.pathname}
          returnDataListToDashboardFunc={this.getDataListFromPropsFunc}
          filteredDataList={filteredDataList}
          tableFrom={tableFrom}
          userId={this.props.userId}
          userName={this.props.userName}
          userPermission={this.props.userPermission}
          systemEnvironment={this.props.systemEnvironment}
          stateHandler={this.props.stateHandler}
          workLogProps={this.props.workLogProps}
          optsContactUpdater={this.props.optsContactUpdater}
          optsCompanyUpdater={this.props.optsCompanyUpdater}
          workLogDataRefresh={this.props.workLogDataRefresh}
          logDataProcesser={this.props.logDataProcesser}
          comWorkLogFilter={this.props.comWorkLogFilter}
          calendarProps={this.props.calendarProps}
          calendarHandlers={this.props.calendarHandlers}
          isBigSideBar={this.props.isBigSideBar}
          propsPackageFromSkyFamily={this.props.propsPackageFromSkyFamily}
          propsFromSaleSky={this.props.propsFromSaleSky} />

        <footer>
          <span></span>
        </footer>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/salesky/routes/dashboard/SaleSkyDashboardCt.jsx